import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { common, GenericObject, ScreenProps } from '@fnol/library/src/lib';
import { StepWrapper, StepperControls, StyledCardSection } from '@fnol/library/src/components';
import { translations } from '../../lib/consts';
import { useFormikContext } from 'formik';
import AddRoom from '../AddRoom';
import { getFloorDamageTypes, getFloorTypes, getRoomTypes, getWallFinishTypes } from '../../rpc/actions';
import { useApi } from '@fnol/library/src/hooks';
import DamagedRoomsTable from '../DamagedRoomsTable/DamagedRoomsTable';

interface FormData {
    roomTypesList: Array<GenericObject>;
    wallFinishTypesList: Array<GenericObject>;
}

const SpecificationDetailScreen = ({ navigator }: ScreenProps) => {
    const { values, isSubmitting, submitForm, setFieldValue } = useFormikContext<GenericObject>();
    const [currentStep, { goForward, goBack }] = navigator;
    const [inputRoomOpen, setInputRoomOpen] = useState(false);
    const [inputRoomId, setInputRoomId] = useState(0);
    const [addPossible, setAddPossible] = useState(true);
    const [missingSpecification, setMissingSpecification] = useState(false);

    const saveRoomTypes = (res: GenericObject) => {
        setFieldValue('roomTypesList', res.data);
    };
    const { response: roomTypesList, fetchMethod: fetchRoomTypes } = useApi(() => getRoomTypes(), saveRoomTypes);

    const saveWallFinishTypes = (res: GenericObject) => {
        setFieldValue('wallFinishTypesList', res.data);
    };
    const { response: wallFinishTypesList, fetchMethod: fatchWallFinishTypes } = useApi(
        () => getWallFinishTypes(),
        saveWallFinishTypes,
    );

    const handleNext = (): void => {
        if (validNumberOfSpecification()) {
            submitForm();
        } else {
            setMissingSpecification(true);
        }
    };

    const validNumberOfSpecification = (): boolean => {
        let damagedRoomIds = [0];
        let countOfSpecification = 0;
        if (values.damagedRooms && values.damagedRooms === 1) damagedRoomIds = [1];
        else if (values.damagedRooms && values.damagedRooms === 2) damagedRoomIds = [1, 2];
        else if (values.damagedRooms && values.damagedRooms === 3) damagedRoomIds = [1, 2, 3];

        damagedRoomIds.map((damagedRoomId) => {
            if (values[`room${damagedRoomId}Area`] && values[`room${damagedRoomId}Area`] !== '') {
                countOfSpecification = countOfSpecification + 1;
            }
        });

        if (damagedRoomIds.length === countOfSpecification) return true;

        return false;
    };

    const handleGoBack = (): void => {
        goBack();
    };

    useEffect(() => {
        fetchRoomTypes();
        fatchWallFinishTypes();
    }, []);

    useEffect(() => {
        setMissingSpecification(false);
    }, [inputRoomOpen]);

    useEffect(() => {
        if (values.submittedSuccessfully) {
            goForward();
        }
    }, [values.submittedSuccessfully]);

    return (
        <StepWrapper>
            <StyledCardSection>
                <Typography style={{ fontWeight: 'bold', fontSize: '1.1rem' }} variant="caption">
                    {translations.specificationDetail.SPECIFICATION}
                </Typography>
                <DamagedRoomsTable
                    inputRoomOpen={inputRoomOpen}
                    setInputRoomOpen={setInputRoomOpen}
                    setInputRoomId={setInputRoomId}
                    setAddPossible={setAddPossible}
                />
                <AddRoom
                    inputRoomOpen={inputRoomOpen}
                    setInputRoomOpen={setInputRoomOpen}
                    inputRoomId={inputRoomId}
                    setInputRoomId={setInputRoomId}
                    addPossible={addPossible}
                    setAddPossible={setAddPossible}
                ></AddRoom>
            </StyledCardSection>
            {missingSpecification ? (
                <Typography className="confirmation-message" id="msgSent">
                    {`${translations.addRoom.ERROR_MSG_MISSING_SPECIFICATION} ${values.damagedRooms}.`}
                </Typography>
            ) : (
                <></>
            )}
            {isSubmitting ? (
                <CircularProgress />
            ) : (
                <StepperControls
                    onNext={!values.inputRoomOpen ? handleNext : undefined}
                    onNextLabel={common.NEXT}
                    onPrevious={!values.inputRoomOpen ? handleGoBack : undefined}
                    onPreviousLabel={common.PREVIOUS}
                    idNext="specificationScreenNext"
                    idPrevious="specificationScreenPrevious"
                />
            )}
        </StepWrapper>
    );
};

export default SpecificationDetailScreen;
